<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container class="px-6">
    <page-header>{{ $t('dinnerPrice') }}</page-header>

    <div class="mt-4">
      <template v-if="priceDishes.length>0">
        <v-card
          v-for="(bp,index) in priceDishes"
          :key="bp.id"
          class="pa-4 d-flex align-center mb-2"
          outlined
        >
          <div>
            {{ bp.code }}.{{ bp.name }}
          </div>


          <v-spacer/>
          <v-chip
            class="mr-2"
            small
          >
            {{ bp.isForAdult ? $t('adult') : $t('kid') }}
          </v-chip>
          <div class="mr-4">
            {{ bp.price|priceDisplay }}
          </div>
          <v-menu
            close-on-content-click
            left
            offset-overflow
            offset-y
            rounded
          >
            <template #activator="{on,attrs}">
              <v-btn
                v-bind="attrs"
                icon
                outlined
                style="border-radius: 12px"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list
              outlined
              width="200px"
            >
              <v-list-item-group>
                <v-list-item @click="editItem(index)">
                  <v-list-item-title>{{ $t('open') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteItem(bp.id)">
                  <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-card>
      </template>
      <template v-else>
        <v-card
          class="pa-4 py-6"
          outlined
        >
          {{ $t('noPriceClickAdd') }}
        </v-card>
      </template>
    </div>

    <v-btn
      class="mt-4"
      color="primary"
      elevation="0"
      @click="editItem(-1)"
    >
      {{ $t('newDinnerPrice') }}
    </v-btn>
    <ik-entity-form
      v-model="showDialog"
      :edited-index="activeIndex"
      :model="model"
      :out-side-list="priceDishes"
      :out-side-property="{consumeTypeId : consumeTypeId}"
      :title="$t('price')"
      @need-refresh="getCurrentPriceDishes"
    />
  </v-container>
</template>

<script>
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import BuffetPrice from '@/model/buffet/BuffetPrice'
  import { IkEntityForm } from 'metaflow-js'
  import { showSuccessMessage, sureToDelete } from '@/common/utils'
  import IKUtils from 'innerken-js-utils'

  export default {
    name: 'BuffetPriceDishFragment',
    components: {
      PageHeader,
      IkEntityForm,
    },
    props: {
      consumeTypeId: {},
    },
    data: function () {
      return {
        model: BuffetPrice,
        showDialog: null,
        priceDishes: [],
        activeIndex: -1,
      }
    },
    watch: {
      async consumeTypeId (val) {
        await this.getCurrentPriceDishes()
      },
    },
    mounted () {
      this.getCurrentPriceDishes()
    },
    methods: {
      editItem (index) {
        this.activeIndex = index
        this.showDialog = true
      },
      async deleteItem (id) {
        await sureToDelete(async () => {
          IKUtils.showLoading()
          await this.model.remove(id)
          await this.getCurrentPriceDishes()
          showSuccessMessage()
        })
      },
      async getCurrentPriceDishes () {
        try {
          this.priceDishes = await BuffetPrice.getList(true, { consumeTypeId: this.consumeTypeId ?? 1 })
        } catch (e) {
          console.log(e)
        }
      },
    },
  }
</script>

<style scoped>

</style>
